import classNames from "classnames";


export const Notification = ({ onClick, title, message, type, ...props }) => {
  const iconClasses = () => {
    switch (type) {
      case "success":
        return "icon-[ph--check-circle] text-success-600 dark:text-success-400";
      case "error":
        return "icon-[ph--x-circle] text-error-600 dark:text-error-400";
      case "warning":
        return "icon-[ph--warning-diamond] text-warning-600 dark:text-warning-400";
      case "info":
        return "icon-[ph--info] text-info-600 dark:text-info-300";
      default:
        return "icon-[ph--info] text-content-800 dark:text-content-100";
    }
  };

  const textClasses = () => {
    switch (type) {
      case "success":
        return "text-success-600 dark:text-success-400";
      case "error":
        return "text-error-600 dark:text-error-400";
      case "warning":
        return "text-warning-600 dark:text-warning-400";
      case "info":
        return "text-info-600 dark:text-info-300";
      default:
        return "text-content-800 dark:text-content-100";
    }
  };

  return (
    <div
      onClick={onClick}
      className="mb-2 grid grid-cols-12 gap-4 rounded-xl border border-content-200/60 bg-white py-4 pl-4 shadow-lg shadow-content-900/10 dark:border-primary-800/60 dark:bg-content-900 dark:shadow-content-950/40"
      {...props}
    >
      <div className="col-span-1 flex flex-col items-center justify-start">
        <div className={classNames(iconClasses(), "h-8 w-7")} />
      </div>
      <div className="col-span-11">
        <div
          className={classNames(
            textClasses(),
            "font-header text-lg font-medium"
          )}
        >
          {title}
        </div>
        {message && message?.length > 0 && (
          <div className={classNames(textClasses(), "text-md font-sans")}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};
